import styled from 'styled-components';

export const PageBanner = styled.section`
  position: relative;
  padding: 6rem 1.5rem 4.5rem;
  background: ${({ theme }) => theme.colors.nearBlack};
  color: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  text-align: center;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: ${({ $src }) => ($src ? `url(${$src})` : 'none')};
    background-size: cover;
    background-position: center;
    opacity: ${({ $src }) => ($src ? 0.35 : 0)};
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.8) 100%);
  }
`;

export const BannerContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 0 auto;

  .eyebrow {
    display: inline-block;
    font-size: 0.78rem;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.goldLight};
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gold};
  }

  h1 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: clamp(2rem, 5vw, 3.5rem);
    color: #fff;
    line-height: 1.1;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.05rem;
    color: rgba(255,255,255,0.78);
    max-width: 680px;
    margin: 0 auto;
  }
`;

export const Section = styled.section`
  padding: ${({ $tight }) => ($tight ? '3rem' : '5rem')} 1.5rem;
  background: ${({ theme, $alt }) => ($alt ? theme.colors.offWhite : theme.colors.white)};
`;

export const Container = styled.div`
  max-width: 1180px;
  margin: 0 auto;
`;

export const Eyebrow = styled.span`
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.goldDark};
  padding-left: 2.5rem;
  position: relative;
  margin-bottom: 0.75rem;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 32px;
    height: 2px;
    background: ${({ theme }) => theme.colors.gold};
  }
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(1.8rem, 3.5vw, 2.6rem);
  color: ${({ theme }) => theme.colors.nearBlack};
  margin-bottom: 1rem;
  line-height: 1.15;

  span {
    color: ${({ theme }) => theme.colors.goldDark};
    font-style: italic;
  }
`;

export const SectionLead = styled.p`
  font-size: 1.05rem;
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 720px;
  line-height: 1.75;
  margin-bottom: 2rem;
`;

export const GoldDivider = styled.div`
  width: 60px;
  height: 3px;
  background: ${({ theme }) => theme.colors.gold};
  margin: ${({ $center }) => ($center ? '0 auto 1.25rem' : '0 0 1.25rem')};
`;

export const PrimaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.95rem 1.75rem;
  background: ${({ theme }) => theme.colors.nearBlack};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  border: 1px solid ${({ theme }) => theme.colors.nearBlack};
  transition: ${({ theme }) => theme.transitions.base};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.gold};
    color: ${({ theme }) => theme.colors.nearBlack};
    border-color: ${({ theme }) => theme.colors.gold};
  }
`;

export const OutlineButton = styled(PrimaryButton).attrs({ as: 'a' })`
  background: transparent;
  color: ${({ theme }) => theme.colors.white};
  border-color: ${({ theme }) => theme.colors.gold};

  &:hover {
    background: ${({ theme }) => theme.colors.gold};
    color: ${({ theme }) => theme.colors.nearBlack};
  }
`;
